import { Component, OnInit, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { PaymentService } from '../../core/payments/payments.service';
import * as _ from 'lodash';
import * as moment from "moment";

@Component({
  selector: 'payments-chart',
  templateUrl: 'payments-chart.component.html',
  styleUrls: ['payments-chart.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PaymentsChartComponent implements OnInit, AfterViewInit {

  paymentDashboard: any;
  errorPaymentsChart = false;
  paymentsChartErrorMessage = '';

  private isLoading: boolean = false;
  private startDate: Date;
  private endDate: Date;
  private queryDates: Date[] =[];

  constructor(private paymentService: PaymentService) {

    const now = moment().toDate();
    this.startDate = now;
    this.endDate = now;
    this.queryDates = [now, now];

  }

  ngOnInit(): void {
    this.errorPaymentsChart = false;
  }

  ngAfterViewInit(): void {
    this.updatePayments();
  }

  invalidDateRange(): boolean {

    return _.isNil(this.queryDates[0]) ||
      _.isNil(this.queryDates[1]);
  }

  updatePayments(): void {

    this.isLoading = true;
    this.paymentService.getPaymentDashboard(this.queryDates)
      .finally(() => this.isLoading = false)
      .subscribe(
        response => {
          this.startDate = this.queryDates[0];
          this.endDate = this.queryDates[1];

          this.errorPaymentsChart = false;
          this.paymentDashboard = response;
        },
        error => {
          console.error('error: ', error);
          this.errorPaymentsChart = true;
          this.paymentsChartErrorMessage = error;
        }
      );
  }


}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/payments/payments-chart.component.ts